import React from 'react';
import { motion } from 'framer-motion';
import { TopClouds, BottomClouds } from './HeroClouds';
import { HeroStars } from './HeroStars';

const CONTAINER_INITIAL = { opacity: 0, x: 50 };
const CONTAINER_ANIMATE = { opacity: 1, x: 0 };
const CONTAINER_TRANSITION = { duration: 0.8 };
const ROCKET_FLOAT_ANIMATE = { y: [-20, 20, -20] };
const ROCKET_FLOAT_TRANSITION = { duration: 5, repeat: Infinity, ease: 'easeInOut' };
const ROCKET_ROT_ANIMATE = { rotate: [0, 3, -3, 0] };
const ROCKET_ROT_TRANSITION = { duration: 4, repeat: Infinity, ease: 'easeInOut' };

const HeroRocket = () => (
  <motion.div
    initial={CONTAINER_INITIAL}
    animate={CONTAINER_ANIMATE}
    transition={CONTAINER_TRANSITION}
    className="relative flex items-center justify-center"
  >
    <TopClouds />
    <motion.div
      animate={ROCKET_FLOAT_ANIMATE}
      transition={ROCKET_FLOAT_TRANSITION}
      className="relative w-[300px] h-[300px] md:w-[400px] md:h-[400px] lg:w-[500px] lg:h-[500px] z-10"
    >
      <div className="absolute inset-0 bg-gradient-to-r from-red-500/30 via-orange-500/30 to-yellow-500/30 rounded-full blur-3xl animate-pulse" />
      <motion.img
        src="/rocket.png"
        alt="MRK Digital Rocket"
        data-testid="hero-rocket-img"
        className="relative z-10 w-full h-full object-contain drop-shadow-2xl"
        animate={ROCKET_ROT_ANIMATE}
        transition={ROCKET_ROT_TRANSITION}
      />
      <HeroStars />
    </motion.div>
    <BottomClouds />
  </motion.div>
);

export default HeroRocket;
